module.exports = __webpack_public_path__ + "static/media/breedon.7430f5dd.png";